export const roundToOneDecimal = (value) => {
  const floatVal = parseFloat(value);
  if (Number.isNaN(floatVal)) {
    // return empty string if value is not a number
    // to make output predictable
    return '';
  }

  return (Math.floor(floatVal * 10) / 10).toFixed(1);
};

export const roundToTwoDecimals = (value) => {
  const floatVal = parseFloat(value);
  if (Number.isNaN(floatVal)) {
    // return empty string if value is not a number
    // to make output predictable
    return '';
  }

  return (Math.floor(floatVal * 100) / 100).toFixed(2);
};
